/**
 * Generic Modal.
 */
import { StyleSheet, Platform } from 'react-native';
import styled from 'styled-components/native';
import { color, ColorProps } from 'styled-system';

import { Colors } from 'theme/colors';
import { FontFamily, FontSize, FontWeight } from 'theme/fonts';
import { FontProps } from 'theme/text';

export const Description = styled.Text<ColorProps>`
  text-align: center;
  color: ${Colors.black};
  font-size: ${FontSize.H6};
  font-family: ${Platform.OS === 'web' ? 'Roboto' : FontFamily.Light};
  font-weight: ${FontWeight.Light};
  margin-right: 30px;
  margin-left: 30px;
  margin-top: 5px;
  line-height: 21px;
  font-weight: 100;
  ${color}
`;

export const Container = styled.View``;

export const ModalContent = styled.View`
  background-color: ${Colors.siam};
  border-radius: 15px;
  overflow: hidden;
  max-width: 400px;
  margin-left: 20px;
  margin-right: 20px;

  ${Platform.OS !== 'web'
    ? ''
    : `
    align-self: center;
    width: 100%;
  `}
`;

export const ModalInner = styled.View`
  background-color: ${Colors.white};
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  overflow: hidden;
  padding-top: 47px;
  padding-bottom: 47px;
`;

export const HeaderContainer = styled.View`
  background-color: ${Colors.siam};
  padding-top: 17px;
  padding-bottom: 17px;
  justify-content: center;
  align-items: center;
  height: 56px;
`;

export const ButtonDivider = styled.View`
  height: 100%;
  width: ${StyleSheet.hairlineWidth}px;
  background-color: ${Colors.white};
`;

export const Button = styled.TouchableOpacity<ColorProps>`
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 15px;
  padding-left: 15px;
  background-color: ${Colors.green};
  justify-content: center;
  align-items: center;
  flex: 1;
  ${color}
`;

/**
 * Gets the font size with the correct format
 *
 * @param fontSize - the font size as either number or FontSize type
 */
function getFontSize(fontSize: number | FontSize = FontSize.H2) {
  if (typeof fontSize === 'number') {
    return `${fontSize}px`;
  }

  return fontSize;
}
export const Title = styled.Text`
  color: ${Colors.black};
  font-family: ${Platform.OS === 'web' ? 'Roboto' : FontFamily.Light};
  font-size: ${({ fontSize }: FontProps) => getFontSize(fontSize)};
  font-weight: ${({ fontWeight }: FontProps) => fontWeight || FontWeight.Light};
  text-align: center;
  margin-bottom: 10px;
`;

export const Footer = styled.View`
  background-color: ${Colors.white};
  border-top-width: 1px;
  border-top-color: ${Colors.mischka};
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const BackButton = styled.TouchableOpacity`
  position: absolute;
  top: 20px;
  left: 20px;
  height: 30px;
  width: 30px;
`;

export const IconContainer = styled.View`
  padding-top: 10px;
  padding-bottom: 20px;
  align-items: center;
`;

export const Circle = styled.View`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  justify-content: center;
  align-items: center;
`;

export const Span = styled.View``;

export const CancelButton = styled.TouchableOpacity`
  margin-bottom: 20px;
`;

export const OverlayContent = styled.View`
  flex: 1;
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: center;
`;

export const Paragraph = styled.Text`
  font-size: ${FontSize.H5};
  font-family: ${FontFamily.Light};
  color: ${Colors.white};
  text-align: center;
  line-height: 24px;
  margin-bottom: 20px;
`;

export const Content = styled.View``;

export const Overlay = styled.View``;
